import { filterCatalog } from "./filter.js";
function init() {

    filterCatalog();
}

export {
    init   
}